/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import RefundedbagQueryResult from './RefundedbagQueryResult';

/**
 * The RefundedbagOutputCmsRecords model module.
 * @module model/RefundedbagOutputCmsRecords
 * @version 1.0
 */
class RefundedbagOutputCmsRecords {
    /**
     * Constructs a new <code>RefundedbagOutputCmsRecords</code>.
     * @alias module:model/RefundedbagOutputCmsRecords
     */
    constructor() { 
        
        RefundedbagOutputCmsRecords.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RefundedbagOutputCmsRecords</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RefundedbagOutputCmsRecords} obj Optional instance to populate.
     * @return {module:model/RefundedbagOutputCmsRecords} The populated <code>RefundedbagOutputCmsRecords</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RefundedbagOutputCmsRecords();

            if (data.hasOwnProperty('records')) {
                obj['records'] = ApiClient.convertToType(data['records'], [RefundedbagQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/RefundedbagQueryResult>} records
 */
RefundedbagOutputCmsRecords.prototype['records'] = undefined;






export default RefundedbagOutputCmsRecords;

